import TrashIcon from "../../assets/trash-outline.svg";
import { CurrencyInputField } from "../Common/currencyInput";

interface AddValueBoxProps {
  title: string;
  amount: string;
  error?: string;
  onAmountChange: (newAmount: string) => void;
  onDelete: () => void;
}

const AddValueBox = ({
  title,
  amount,
  error,
  onAmountChange,
  onDelete,
}: AddValueBoxProps) => {
  return (
    <div className="rounded-[8px] border-[#E5E7EB] border-2">
      <div className="font-medium flex items-center justify-between w-full bg-[#E5E7EB]/50 rounded-t-[8px] border-b-[#E5E7EB] border-b-2 px-3 py-4">
        <div>{title}</div>
        <button
          type="button"
          onClick={onDelete}
          className="flex items-center gap-1 text-[#EF4444] text-xs font-medium"
        >
          Delete <img src={TrashIcon} alt="Delete" />
        </button>
      </div>
      <div className="p-4 space-y-1 w-full lg:w-1/2">
        <CurrencyInputField
          id="amount"
          label="Amount"
          placeholder="Enter amount"
          value={amount}
          onChange={onAmountChange}
        />
        {error && <div className="text-red-600 text-xs">{error}</div>}
      </div>
    </div>
  );
};

export { AddValueBox };
